import axiosInstance from "./axiosInstance";
export const checkTeamWalletById = async (userId) => {
  try {
    const response = await axiosInstance.get(`/api/wallet/team_wallet/${userId}`);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const sendAepsToMain = async (payload) => {
  try {
    const response = await axiosInstance.post(`/api/wallet/aeps-to-main`,payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
